<template>

  <section class="login">
    <div class="container-scroller">
      <div class="container-fluid page-body-wrapper full-page-wrapper">
        <div class="content-wrapper d-flex align-items-center auth">
          <div class="row w-100 flex-grow">
            <div class="col-xl-4 col-lg-6 mx-auto">
              <div class="auth-form-light text-left p-5">
                <div class="brand-logo">
                  <img src="../../../assets/images/logo.png">
                </div>
                <h4>Hello! let's get started</h4>
                <h6 class="font-weight-light">Put in OTP to continue</h6>
                <ValidationObserver v-slot="{ invalid }">
                <form @submit.prevent="onSubmit" class="pt-3">
                  <ValidationProvider name="token" rules="required">
                    <div slot-scope="{ errors }" class="form-group">
                      <input type="text" v-model="token" class="form-control form-control-lg" id="token" placeholder="Token">
                      <p>{{ errors[0] }}</p>
                    </div>
                  </ValidationProvider>
                  <div class="mt-3">
                    <b-button type="submit" :disabled="invalid" variant="primary" class="btn btn-block btn-gradient-primary btn-lg font-weight-medium auth-form-btn">{{ sign_in }}</b-button>
                  </div>
                  <div class="my-4 d-flex justify-content-between align-items-center">
                    Don't have an OTP? <router-link :to="{name: 'login'}">Sign In</router-link>
                  </div>
                </form>
                </ValidationObserver>
              </div>
            </div>
          </div>
      </div>
      <!-- content-wrapper ends -->
      </div>
      <!-- page-body-wrapper ends -->
    </div>
    <vue-snotify></vue-snotify>
  </section>

</template>

<script>
import { ValidationObserver } from 'vee-validate'

export default {
  name: 'verify',
  data() {
    return {
      token: '',
      sign_in: "SIGN IN"
    }
  },
  components: {
    ValidationObserver
  },
  methods: {
    checkLogin() {
      if (this.$store.state.auth.isUserLoggedIn()) {
        this.$snotify.warning('User already logged in', {
          timeout: 2000,
          showProgressBar: true,
          closeOnClick: false,
          pauseOnHover: true

        })
        return false
      }
      return true
    },
    onSubmit() {
      this.sign_in = "PROCESSING..."
      if (!this.checkLogin()) return
      const payload = {
        userDetails: {
          token: this.token,
        }
     }
     this.$store.dispatch('auth/verifyJWT', payload)
     .then(() => {   
        this.$snotify.success("Signed in successfully!", {
          timeout: 2000,
          showProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true
       })
      })
      .catch(error => {
        this.sign_in = "SIGN IN"
        this.$snotify.warning(error, {
          timeout: 2000,
          showProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true

        })
      })
    }
  }
}
</script>
<style scoped lang="scss">
.simple-snotify {
  display: flex;
  justify-content: center;
}
</style>
